import { PayloadAction } from "@reduxjs/toolkit";
import { EmployeesState } from "../../models/EmployeesState";
import { UpdateEmployeePayload } from "../../payload/UpdateEmployee/UpdateEmployeePayload";

const updateEmployeeFetch = (state: EmployeesState, action: PayloadAction<UpdateEmployeePayload>) => {
    state.isLoading = true;
}

export default updateEmployeeFetch;